/** Audience listable dans le rail : présente et pas encore passée. */
export function upcomingHearingAt(
  nextHearingAt: string | null,
  now: Date,
): string | null {
  if (!nextHearingAt) return null;
  if (new Date(nextHearingAt).getTime() < now.getTime()) return null;
  return nextHearingAt;
}
